export default __webpack_public_path__ + "static/media/HomeTemperature.be887e03.svg";